import React from 'react';

const BlogPage = () => {
  return <>BlogPage</>;
};

export default BlogPage;
